import { BULK_PAYMENT_EXECUTION_DONE } from 'constants/events/bulkPayment';

export default response => dispatch =>
  dispatch({
    type: BULK_PAYMENT_EXECUTION_DONE,
    payload: response,
  });
